import ContentfulEntryCard from './container'
export default ContentfulEntryCard
